//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  required, email, sameAs
} from 'vuelidate/lib/validators'
import Password from 'vue-password-strength-meter'
import AxiosErrorHandler from '@/mixins/AxiosErrorHandler'
import HCaptchaInput from '@/components/form/HCaptchaInput'
import Captcha from '@/mixins/Captcha'
import passwordStrength from '../../validations/passwordStrength'
import ValidationMessages from '../form/ValidationMessages.vue'

const initialForm = {
  email: '',
  password: '',
  passwordConfirmation: '',
  role: null,
  token: null
}

// noinspection JSUnusedGlobalSymbols
export default {
  name: 'RegisterForm',
  components: {
    HCaptchaInput,
    ValidationMessages,
    Password
  },
  mixins: [AxiosErrorHandler, Captcha],
  props: {
    role: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      form: {
        ...initialForm
      },
      sending: false
    }
  },
  validations: {
    form: {
      email: {
        required,
        email
      },
      password: {
        required,
        // minLength: minLength(8),
        passwordStrength
      },
      passwordConfirmation: {
        required,
        // minLength: minLength(8),
        sameAsPassword: sameAs('password')
      }
    }
  },
  methods: {
    /**
     * Register
     * @return {Promise<void>}
     */
    async register () {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.sending = true

        try {
          const regData = {
            ...this.form,
            role: this.role
          }

          const { referrer } = this.$route.query
          if (referrer) {
            regData.referrer = referrer
          }

          await this.$store.dispatch('user/register', regData)
          this.form = { ...initialForm }
          this.$v.$reset()
          this.sending = false
          await this.$store.dispatch('ui/showNotification', {
            type: 'success',
            text: this.$t('auth.sign_up.success_notification')
          })
          this.$gtag.event('sign_up', {
            role: this.role,
            method: 'email'
          })
          await this.$router.push(this.localePath('/sign-up/success'))
        } catch (err) {
          this.sending = false
          await this.handleError(err)
        }
      }
    }
  }
}
